import React, { useRef } from 'react';
import { LayoutDashboardLeftMenuSupportStyle as S } from './LayoutDashboardLeftMenuSupport.style';
import { LayoutDashboardLeftMenuItem } from '../LayoutDashboardLeftMenuItem/LayoutDashboardLeftMenuItem';
import { PMenu } from 'components/prime/PMenu/PMenu';
import { Menu } from 'primereact/menu';

export const LayoutDashboardLeftMenuSupport: React.FC = () => {
  const ref = useRef<Menu>(null);

  return (
    <S.Container>
      <LayoutDashboardLeftMenuItem
        item={{ name: 'Support', icon: 'helpCircleLine' }}
        onClick={(event) => ref?.current?.toggle(event)}
      />
      <PMenu
        ref={ref}
        model={[
          {
            label: 'Help center',
            url: 'https://intercom.help/yabblezone/en/',
            target: '_blank',
          },
          {
            label: 'Contact support',
            url: `${window.location.origin}/contact`,
            target: '_blank',
          },
        ]}
        appendTo="self"
        popupAlignment="right"
        popup
      />
    </S.Container>
  );
};
